var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-builder',{attrs:{"chart":_vm.encounters.content,"treeFilter":_vm.treeFilter,"editMode":_vm.editMode,"selectedRecord":_vm.selectedRecord}})
}
var staticRenderFns = []

export { render, staticRenderFns }